import { render, staticRenderFns } from "./form.vue?vue&type=template&id=193f86a7&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193f86a7')) {
      api.createRecord('193f86a7', component.options)
    } else {
      api.reload('193f86a7', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=193f86a7&", function () {
      api.rerender('193f86a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/tax-office/form.vue"
export default component.exports